import React, {Component} from 'react';
import {
    Chip,
    Grid,
    Paper,
    withStyles,
    Typography /* Button */,
} from 'material-ui';
import {connect} from 'react-redux';
import {
    deleteSection,
    disableSection,
    enableSection,
    pickParentPage,
    moveSection,
    openMetaPageSection,
    updateNewUrl,
    updateNoIndex,
    openEditUrlPopup,
    closeEditUrlPopup,
    openEditProductTagosIdPopup,
    closeEditProductTagosIdPopup,
    updateProductTagosId,
    doneEditProductTagosId,
    openEditPageTagsPopup,
    closeEditPageTagsPopup,
    onMultipleTagsUpdate,
    updatePageTags,
    doneEditPageTags,
    discardChanges,
    setPagePreview,
    hasError,
} from '../../actions';
import {builderStyles} from '../../style/builder';
import classNames from 'classnames';
import {getActiveSections} from '../../selectors/active_sections';
import PageBuilderWarning from '../../builder_warning';
import PageBuilderMeta from './builder_meta';
import SectionListEditable from './section_list';
import Sticky from 'react-sticky-el';
import {LinearProgress} from 'material-ui/Progress';
import {
    getPage,
    savePage,
    searchBlocksByTermsOfPage,
    validateUrl,
} from '../../thunks';
import {fetchFaqsTypes} from '../../../faqs/thunks';
import {createPageClones, fetchPageTagsByPageType} from '../../../pages/thunks';
import {
    SECTION_TYPE_MAP,
    SECTION_TYPE_FORM,
    SECTION_TYPE_TEXT,
} from '../../constants';
import DeleteDialog from '../../form/delete_section_dialog';
import EnableDialog from '../../form/enable_section_dialog';
import DisableDialog from '../../form/disable_section_dialog';
import StaffPopup from '../../form/popups/staff_popup';
import ItineraryPopup from '../../form/popups/itinerary_popup';
import ReviewsPopup from '../../form/popups/reviews_popup';
import OverviewPopup from '../../form/popups/overview_popup';
import TextPopup from '../../form/popups/text_popup';
import TextColumnsSingleMediaPopup from '../../form/popups/text_columns_single_media_popup';
import BlockPopup from '../../form/popups/block_popup';
import MapPopup from '../../form/popups/map_popup';
import MetaPopup from '../../form/popups/meta_popup';
import PartnersPopup from '../../form/popups/partners_popup';
import FormPopup from '../../form/popups/form_popup';
import TripFormatsSnippetsPopup from '../../form/popups/trip_formats_popup';
import ProductSnippetsPopup from '../../form/popups/product_snippets_popup';
import InternalLinksPopup from '../../form/popups/internal_links_popup';
import CallToActionPopup from '../../form/popups/call_to_action_popup';
import NextStepsPopup from '../../form/popups/next_steps_popup';
import ReviewSnippetsPopup from '../../form/popups/review_snippets_popup';
import FaqsPopup from '../../form/popups/faqs_popup';
import FindYourProjectPopup from '../../form/popups/find_your_project_popup';
import LargeSnippetsPopup from '../../form/popups/large_snippets_popup';
import ValueProposition from '../../form/popups/value_proposition_popup';
import MeetUsPopup from '../../form/popups/meet_us_popup';
import TripFormatsCarouselPopup from '../../form/popups/trip_formats_carousel_popup';
import GroupTripsBannerSectionPopup from '../../form/popups/group_trips_banner_popup';
import PromotionalBoxesPopup from '../../form/popups/promotional_boxes_popup';
import TextColumnsMultipleMediaPopup from '../../form/popups/text_columns_multiple_media_popup';
import {openMetaPageSectionPopup} from '../../meta/actions';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import PagePicker from '../../../page-picker/page_picker';
import {onSearchPages} from '../../../page-picker/thunks';
import {clearPageSearchFilter} from '../../../page-picker/actions';
//import {showToasterErrorMessage, showToasterLightMessage} from '../../../../components/helpers/helpers'; // Hide pop-up messages, do not delete yet
//import {showErrMsgPopup} from '../../../../components/helpers/helpers'; // To fix Blocks updates in pages
import {toastr} from 'react-redux-toastr';
import Loader from 'react-loader-advanced';
import UrlPopup from '../../form/popups/url_popup';
import ProductTagosIdPopup from '../../form/popups/product_tagos_id_popup';
import PageTagsPopup from '../../form/popups/page_tags_popup';
import {BackButton} from '../../../../components/buttons/BackButton';
import ScrollToTop from '../../../../components/scroll-top/ScrollToTop';
import TagsDisplayList from '../../tags_display_list';
import TranslatePageDialog from '../../../pages/PageTranslateDialog';

import {fetchMissingPageTranslations} from './../../../pages/thunks';

import {fetchSites} from '../../../sites/thunks';
import {
    clearAddTranslationSites,
    selectAllAddTranslationSites,
    updateAddTranslationSites,
} from '../../../pages/actions';

class PageSectionsEditable extends Component {
    constructor(props) {
        super(props);
        this.handleDeleteSection = this.handleDeleteSection.bind(this);
        this.handleEnableSection = this.handleEnableSection.bind(this);
        this.handleDisableSection = this.handleDisableSection.bind(this);
    }

    state = {
        openDeleteDialog: false,
        toDeleteSectionId: null,
        openEnableDialog: false,
        toEnableSectionId: null,
        openDisableDialog: false,
        openPagePicker: false,
        openTranslate: false,
        toDisableSectionId: null,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.pageSections !== null;
    }

    async handleDisableSection() {
        await this.props.disableSection(
            this.props.pageId,
            this.state.toDisableSectionId
        );
        await this.setState({
            openDisableDialog: false,
            toDisableSectionId: null,
        });
    }

    async handleEnableSection() {
        await this.props.enableSection(
            this.props.pageId,
            this.state.toEnableSectionId
        );
        await this.setState({
            openEnableDialog: false,
            toEnableSectionId: null,
        });
    }

    async handleDeleteSection() {
        await this.props.deleteSection(
            this.props.pageId,
            this.state.toDeleteSectionId
        );
        await this.setState({
            openDeleteDialog: false,
            toDeleteSectionId: null,
        });
    }

    componentDidMount() {
        this.props.searchBlocksByTermsOfPage(this.props.pageId);
        this.props.getPage(this.props.pageId);
        if (this.props.page.type_id === 23) {
            this.props.fetchFaqsTypes();
        }
        // Hide pop-up messages for now, in the future find a way to maybe only display them once per session
        //showToasterLightMessage('Please enable your browser to ALLOW POP-UPS in order to open the page PREVIEW!');
    }

    // Hide pop-up messages for now, in the future find a way to maybe only display them once per session, do not delete yet
    // componentWillUpdate(nextProps) {
    //     if (nextProps.isDirty === false && (!nextProps.page.url || !nextProps.page.parent_page.title)) {
    //         showToasterErrorMessage("You have to add an URL, pick a Parent Page and fill in ALL the mandatory fields (marked with *) in each section before saving the page!")
    //     }
    // }

    componentWillUnmount() {
        toastr.removeByType('error');
        toastr.removeByType('light');
    }

    handleCloseDeleteSectionDialog = () => {
        this.setState({
            openDeleteDialog: false,
            toDeleteSectionId: null,
        });
    };

    handleCloseEnableSectionDialog = () => {
        this.setState({
            openEnableDialog: false,
            toEnableSectionId: null,
        });
    };

    handleCloseDisableSectionDialog = () => {
        this.setState({
            openDisableDialog: false,
            toDisableSectionId: null,
        });
    };

    handlePagePickerClose = () => {
        this.setState({
            openPagePicker: false,
        });
        this.props.clearPageSearchFilter();
    };

    handleSavePage() {
        this.props.savePage(
            this.props.pageId,
            this.props.allSections,
            this.props.page,
            false
        );
    }

    handleSavePreview() {
        this.props.savePage(
            this.props.pageId,
            this.props.allSections,
            this.props.page,
            true
        );
    }

    handleClickOpenTranslate() {
        this.props.fetchSites();
        this.props.fetchMissingPageTranslations(this.props.pageId);
        this.setState({
            openTranslate: true,
        });
    }

    handleRequestCloseTranslate = () => {
        this.props.clearAddTranslationSites();
        this.setState({
            openTranslate: false,
        });
    };

    translatePage = () => {
        let selectedSites = [];

        this.props.missingPageTranslations.forEach(site => {
            if (site.is_checked) {
                selectedSites.push(site.id);
            }
        });

        if (selectedSites.length > 0) {
            this.props.createPageClones(this.props.pageId, selectedSites);
        }
        this.setState({
            openTranslate: false,
        });
    };

    // To fix Blocks updates in pages
    /* showAlertBeforeSaving = () => {
        showErrMsgPopup("If you leave the page without saving all your changes will be lost! Please save the page before leaving! If you wish to leave without saving please Discard you changes first!");
    } */

    render() {
        const {pageSections} = this.props;

        const {classes} = this.props;

        const buttonClassName = classNames({
            [classes.saveButton]: this.props.loading === false,
            [classes.disabledSaveButton]: this.props.loading === true,
        });

        let saveButtonLabel = this.props.loading ? '' : 'save';

        let displayPopups =
            typeof this.props.page === 'object' && this.props.page.length !== 0;

        let parentPage = !_isEmpty(this.props.page.parent_page)
            ? this.props.page.parent_page.title
            : 'Select Parent Page';

        let blockedPage =
            this.props.page.master !== undefined &&
            this.props.page.master !== null &&
            this.props.page.master.url === null;

        let pageTagsForDisplay = this.props.tagsForDisplay
            ? this.props.tagsForDisplay
            : '';

        let pageUrl = this.props.page.url ? this.props.page.url : '';

        let sectionTypeForm = this.props.allSections.filter(
            (section) => Number(section.type_id) === SECTION_TYPE_FORM
        );

        let sectionTypeText = this.props.allSections.filter(
            (section) => Number(section.type_id) === SECTION_TYPE_TEXT
        );

        let urlHasError = classNames(pageUrl.length < 1 && classes.hasErrors);

        let parentPageHasError = classNames(
            _isEmpty(this.props.page.parent_page) && classes.hasErrors
        );

        let hasTags = Object.values(pageTagsForDisplay).map((item) => item);

        let canSave =
            this.props.isDirty &&
            this.props.page.url.length > 0 &&
            !_isEmpty(this.props.page.parent_page);

        return (
            <Grid className={classNames('pb-sections')} item xs={12} sm={12}>
                <Sticky className={classes.saveWarning}>
                    <span>
                        <PageBuilderWarning
                            page={this.props.page}
                            isDirty={canSave}
                            classes={this.props.classes}
                            buttonClassName={buttonClassName}
                            loading={this.props.loading}
                            saveButtonLabel={saveButtonLabel}
                            hasMissingTranslations={
                                this.props.page.has_missing_translations
                                    ? true
                                    : false
                            }
                            setPagePreview={this.props.setPagePreview}
                            handlePageSave={this.handleSavePage.bind(this)}
                            handlePageDiscard={() => {
                                this.props.discardChanges();
                                this.props.getPage(this.props.pageId);
                            }}
                            handleSetPreview={this.handleSavePreview.bind(this)}
                            handlePageClone={this.handleClickOpenTranslate.bind(
                                this
                            )}
                        />
                        {this.props.uploadProgress !== null && (
                            <Paper
                                elevation={2}
                                className={classes.paperImageUploading}
                            >
                                <LinearProgress
                                    variant="buffer"
                                    color="secondary"
                                    value={this.props.uploadProgress}
                                    valueBuffer={100}
                                    style={{height: '100%'}}
                                />
                                <div className={classes.textImageUploading}>
                                    Uploading, please wait...
                                    {'Upload progress: ' +
                                        this.props.uploadProgress +
                                        '%'}
                                </div>
                            </Paper>
                        )}
                    </span>
                </Sticky>

                <Paper elevation={2} className={classes.marginBottom10}>
                    <Chip
                        label={this.props.page.site}
                        className={classes.chipPageWebsite}
                    />
                    <Chip
                        label={
                            <span>
                                Page Type:{' '}
                                <span className={classes.chipTextGreen}>
                                    {this.props.page.type}
                                </span>
                            </span>
                        }
                    />

                    <Chip
                        label={
                            <span className={classes.chipPageTagsLabel}>
                                <span>Page Tags *:</span>
                                {pageTagsForDisplay &&
                                    hasTags.join('').length > 0 && (
                                        <span className={classes.chipTextGreen}>
                                            <TagsDisplayList
                                                pageTagsForDisplay={
                                                    pageTagsForDisplay
                                                }
                                                classes={classes}
                                            />
                                        </span>
                                    )}
                            </span>
                        }
                        className={classes.chipPageTags}
                        onClick={() => {
                            this.props.openEditPageTagsPopup(
                                pageTagsForDisplay
                            );
                            this.props.fetchPageTagsByPageType(
                                this.props.page.type_id
                            );
                        }}
                    />
                </Paper>

                <Paper elevation={2} className={classes.marginBottom10}>
                    <Chip
                        label={'Parent Page *: ' + parentPage}
                        className={classNames(
                            classes.chipWebsite,
                            parentPageHasError
                        )}
                        onClick={() => {
                            this.setState({
                                openPagePicker: true,
                            });
                        }}
                    />
                    <Chip
                        onClick={() => {
                            this.props.openEditUrlPopup(this.props.page.url);
                        }}
                        label={
                            'URL *: ' +
                            (this.props.page.url
                                ? this.props.page.url
                                : ' not set')
                        }
                        className={urlHasError}
                    />
                    {this.props.page.product_tagos_id && (
                        <Chip
                            onClick={() => {
                                this.props.openEditProductTagosIdPopup(
                                    this.props.page.product_tagos_id
                                );
                            }}
                            label={
                                'Product Tagos ID: ' +
                                this.props.page.product_tagos_id
                            }
                            className={classes.chipWebsite}
                        />
                    )}
                    <Typography
                        variant="caption"
                        color="error"
                        className={classes.mandatoryText}
                    >
                        Fields marked with * are mandatory!
                    </Typography>
                </Paper>

                <UrlPopup
                    open={this.props.openUrlPopup}
                    onUrlChange={(newUrl) => {
                        this.props.updateNewUrl(newUrl);
                    }}
                    onNoIndexChange={(noindex) => {
                        this.props.updateNoIndex(noindex, this.props.page.id);
                    }}
                    url={this.props.newUrl}
                    urlValid={this.props.newUrlValid}
                    noindex={this.props.noindex}
                    onHandleClose={() => {
                        this.props.closeEditUrlPopup();
                    }}
                    onHandleSubmit={() => {
                        this.props.validateUrl(
                            this.props.newUrl,
                            this.props.page.id
                        );
                    }}
                />

                <ProductTagosIdPopup
                    open={this.props.openProductTagosIdPopup}
                    productTagosId={this.props.productTagosId}
                    onHandleClose={() => {
                        this.props.closeEditProductTagosIdPopup();
                    }}
                    onUpdateProductTagosIdField={(newProductTagosId) =>
                        this.props.updateProductTagosId(newProductTagosId)
                    }
                    onHandleSubmit={() =>
                        this.props.doneEditProductTagosId(
                            this.props.productTagosId,
                            this.props.page.id
                        )
                    }
                />

                <PageTagsPopup
                    open={this.props.openPageTagsPopup}
                    pageId={this.props.page.id}
                    pageTagsForDisplay={pageTagsForDisplay}
                    allPageTags={this.props.allPageTags}
                    loading={this.props.loading}
                    onUpdatePageTags={this.props.updatePageTags}
                    onMultipleTagsUpdate={this.props.onMultipleTagsUpdate}
                    hasError={this.props.hasError}
                    metaError={this.props.metaError}
                    onHandleClose={() =>
                        this.props.closeEditPageTagsPopup(this.props.page.id)
                    }
                    onHandleSubmit={() =>
                        this.props.doneEditPageTags(this.props.page.id)
                    }
                />

                <PagePicker
                    open={this.state.openPagePicker}
                    handleClose={this.handlePagePickerClose.bind(this)}
                    onPick={(parentPageId, parentPageTitle) => {
                        this.props.pickPage(
                            this.props.page.id,
                            parentPageId,
                            parentPageTitle
                        );
                        this.setState({
                            openPagePicker: false,
                        });
                        this.props.clearPageSearchFilter();
                    }}
                    searchString={this.props.pageSearchCriteria}
                    onSearchPages={(event) => {
                        this.props.onSearchPages(
                            event.target.value,
                            this.props.page.site_id
                        );
                    }}
                    allPagesBySearchCriteria={
                        this.props.allPagesBySearchCriteria
                    }
                />

                <Loader
                    show={blockedPage}
                    message={'Please edit Master website page first!'}
                >
                    <PageBuilderMeta
                        title={this.props.page.title}
                        page={this.props.page}
                        subheading={this.props.page.subheading}
                        metaTitle={this.props.page.meta_title}
                        metaDescription={this.props.page.meta_description}
                        metaSectionData={this.props.metaSectionData}
                        classes={this.props.classes}
                        loading={this.props.loading}
                        handleRequestOpenDialog={() => {
                            let firstMapSection = _find(
                                this.props.allSections,
                                {
                                    type_id: SECTION_TYPE_MAP,
                                }
                            );

                            let firstMapSectionArr = firstMapSection
                                ? firstMapSection.data.locations
                                : [];

                            let data = {
                                title: this.props.page.title,
                                subheading: this.props.page.subheading,
                                old_url: this.props.page.old_url,
                                hero_video_url: this.props.page.hero_video_url,
                                menu_title: this.props.page.menu_title,
                                breadcrumb_title: this.props.page
                                    .breadcrumb_title,
                                meta_title: this.props.page.meta_title,
                                meta_description: this.props.page
                                    .meta_description,
                                heroImage: this.props.page.heroImage,
                                snippet: this.props.page.snippet,
                                locations: this.props.page.locations,
                                sectionLocations: firstMapSectionArr,
                                review: this.props.page.review,
                                custom: this.props.page.custom,
                                product: this.props.page.product,
                                team_id: this.props.page.team_id,
                                blog: this.props.page.blog,
                            };

                            this.props.openMetaPageSection(
                                this.props.pageId,
                                this.props.id
                            );

                            this.props.openMetaPageSectionPopup(data);
                        }}
                    />

                    <SectionListEditable
                        pageSections={pageSections}
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                        faqsTypes={this.props.faqsTypes}
                        hideActions={false}
                        showEnableSectionDialog={(ev, sectionId) => {
                            this.setState({
                                openEnableDialog: true,
                                toEnableSectionId: sectionId,
                            });
                        }}
                        showDisableSectionDialog={(ev, sectionId) => {
                            this.setState({
                                openDisableDialog: true,
                                toDisableSectionId: sectionId,
                            });
                        }}
                        showDeleteSectionDialog={(ev, sectionId) => {
                            this.setState({
                                openDeleteDialog: true,
                                toDeleteSectionId: sectionId,
                            });
                        }}
                    />
                </Loader>

                {displayPopups && <StaffPopup pageId={this.props.pageId} />}
                {displayPopups && <ItineraryPopup pageId={this.props.pageId} />}
                {displayPopups && <ReviewsPopup pageId={this.props.pageId} />}
                {displayPopups && (
                    <TextPopup
                        pageId={this.props.pageId}
                        sectionTypeText={sectionTypeText}
                    />
                )}
                {displayPopups && (
                    <TextColumnsSingleMediaPopup
                        pageId={this.props.pageId}
                        sectionTypeText={sectionTypeText}
                    />
                )}
                {displayPopups && (
                    <TextColumnsMultipleMediaPopup
                        pageId={this.props.pageId}
                        sectionTypeText={sectionTypeText}
                    />
                )}
                {displayPopups && <BlockPopup pageId={this.props.pageId} />}
                {displayPopups && <MapPopup pageId={this.props.pageId} />}
                {displayPopups && <PartnersPopup pageId={this.props.pageId} />}
                {displayPopups && <OverviewPopup pageId={this.props.pageId} />}
                {displayPopups && (
                    <MetaPopup
                        page={this.props.page}
                        pageId={this.props.pageId}
                    />
                )}
                {displayPopups && (
                    <FormPopup
                        sectionTypeForm={sectionTypeForm}
                        pageId={this.props.pageId}
                    />
                )}
                {displayPopups && (
                    <TripFormatsSnippetsPopup pageId={this.props.pageId} />
                )}
                {displayPopups && (
                    <ProductSnippetsPopup pageId={this.props.pageId} />
                )}
                {displayPopups && (
                    <InternalLinksPopup pageId={this.props.pageId} />
                )}
                {displayPopups && (
                    <CallToActionPopup pageId={this.props.pageId} />
                )}
                {displayPopups && <NextStepsPopup pageId={this.props.pageId} />}
                {displayPopups && (
                    <ReviewSnippetsPopup pageId={this.props.pageId} />
                )}
                {displayPopups && (
                    <FaqsPopup
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                    />
                )}
                {displayPopups && (
                    <FindYourProjectPopup
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                    />
                )}
                {displayPopups && (
                    <LargeSnippetsPopup
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                    />
                )}
                {displayPopups && (
                    <ValueProposition
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                    />
                )}
                {displayPopups && (
                    <MeetUsPopup
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                    />
                )}
                {displayPopups && (
                    <TripFormatsCarouselPopup
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                    />
                )}
                {displayPopups && (
                    <GroupTripsBannerSectionPopup
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                    />
                )}
                {displayPopups && (
                    <PromotionalBoxesPopup
                        pageId={this.props.pageId}
                        siteId={this.props.page.site_id}
                    />
                )}

                <DeleteDialog
                    open={this.state.openDeleteDialog}
                    handleDelete={this.handleDeleteSection}
                    handleCloseDialog={this.handleCloseDeleteSectionDialog}
                    classes={this.props.classes}
                />

                <EnableDialog
                    open={this.state.openEnableDialog}
                    handleEnable={this.handleEnableSection}
                    handleCloseDialog={this.handleCloseEnableSectionDialog}
                    classes={this.props.classes}
                />

                <DisableDialog
                    open={this.state.openDisableDialog}
                    handleDisable={this.handleDisableSection}
                    handleCloseDialog={this.handleCloseDisableSectionDialog}
                    classes={this.props.classes}
                />

                <TranslatePageDialog
                    open={this.state.openTranslate}
                    pageTitle={this.props.page.title}
                    pageSiteId={this.props.page.site_id}
                    missingPageTranslations={this.props.missingPageTranslations}
                    updateAddTranslationSites={
                        this.props.updateAddTranslationSites
                    }
                    handleSubmit={this.translatePage}
                    handleRequestClose={this.handleRequestCloseTranslate}
                    handleSelectAll={this.props.selectAllAddTranslationSites}
                />

                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.buttons}>
                        {
                            // To fix Blocks updates in pages
                            /* this.props.isDirty !== null && this.props.isDirty
                    ?
                        <Button
                            variant="raised"
                            className="floatRight"
                            onClick={this.showAlertBeforeSaving}
                        >
                            Back
                        </Button>
                    :

                     */
                        }
                        <BackButton
                            link={'/pages'}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>

                <ScrollToTop />
            </Grid>
        );
    }
}

let checkStateIsDefined = (state, props) => {
    let pageSections =
        state.pageBuilder.pages[props.pageId] == null
            ? []
            : state.pageBuilder.pages[props.pageId].sections;

    let meta =
        state.pageBuilder.pages[props.pageId] == null
            ? []
            : state.pageBuilder.pages[props.pageId].meta;

    let isDirty =
        state.pageBuilder.pages[props.pageId] == null
            ? null
            : state.pageBuilder.pages[props.pageId].isDirty;

    return {pageSections, meta, isDirty};
};

function mapStateToProps(state, props) {
    let {pageSections, meta, isDirty} = checkStateIsDefined(state, props);
    return {
        pageSections: getActiveSections(pageSections),
        allSections: pageSections,
        page: meta,
        preview: meta.preview,
        isDirty: isDirty,
        loading: state.layout.ajaxCallsInProgress > 0,
        pageSearchCriteria: state.pagePicker.pageSearchCriteria,
        allPagesBySearchCriteria: state.pagePicker.allPagesBySearchCriteria,
        newUrl: state.pageBuilder.newUrl,
        newUrlValid: state.pageBuilder.newUrlValid,
        noindex: meta.noindex,
        openUrlPopup: state.pageBuilder.editUrlPopup.open,
        openProductTagosIdPopup: state.pageBuilder.editProductTagosIdPopup.open,
        productTagosId: state.pageBuilder.productTagosId,
        previewLink: state.pageBuilder.previewLink,
        faqsTypes: state.faqs.faqsTypes,
        openPageTagsPopup: state.pageBuilder.editPageTagsPopup.open,
        allPageTags: state.pages.tagsByPageType,
        tagsForDisplay: state.pageBuilder.tagsForDisplay[props.pageId],
        metaError: state.pageBuilder.editPageTagsPopup.error,
        uploadProgress: state.layout.progressPercent,
        metaSectionData: state.pageBuilderMetaPopup.data,
        missingPageTranslations: state.pages.missingPageTranslations,
    };
}

export default connect(
    mapStateToProps,
    {
        getPage,
        moveSection,
        savePage,
        openMetaPageSection,
        openMetaPageSectionPopup,
        deleteSection,
        disableSection,
        enableSection,
        pickPage: pickParentPage,
        searchBlocksByTermsOfPage,
        onSearchPages,
        clearPageSearchFilter,
        validateUrl,
        updateNewUrl,
        updateNoIndex,
        openEditUrlPopup,
        closeEditUrlPopup,
        openEditProductTagosIdPopup,
        closeEditProductTagosIdPopup,
        updateProductTagosId,
        doneEditProductTagosId,
        openEditPageTagsPopup,
        closeEditPageTagsPopup,
        updatePageTags,
        onMultipleTagsUpdate,
        doneEditPageTags,
        fetchPageTagsByPageType,
        discardChanges,
        setPagePreview,
        fetchFaqsTypes,
        hasError,
        fetchSites,
        fetchMissingPageTranslations,
        updateAddTranslationSites,
        clearAddTranslationSites,
        createPageClones,
        selectAllAddTranslationSites,
    }
)(withStyles(builderStyles)(PageSectionsEditable));



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_edit/sections.js